export const parseStringToBoolean = (value: string) => (value === 'false' ? false : !!value);
